"use strict";

import gsap from "gsap";

const nextProjectInOutAnimation = (a, b) => {
	const projIn = document.querySelector(`.next-proj-container .project:nth-child(${a + 1})`);
	const projOut = document.querySelector(`.next-proj-container .project:nth-child(${b + 1})`);
	const inCont = projIn.querySelectorAll(".project-content > *");
	const inImage = projIn.querySelector(".project-display");
	const outCont = projOut.querySelectorAll(".project-content > *");
	const outImage = projOut.querySelector(".project-display");

	const tl = gsap.timeline();

	if (a > b) {
		tl.to(outImage, { x: "-80%", duration: 0.6, ease: "power2.in" })
			.to(outImage, { opacity: 0, duration: 0.2, ease: "none" }, "<0.3")
			.to(outCont, { stagger: 0.1, duration: 0.6, ease: "power2.in", x: "-100%" }, 0.1)
			.to(outCont, { stagger: 0.1, duration: 0.2, ease: "none", opacity: 0 }, "<")
			.to(projOut, { zIndex: -1000 }, 0)
			.to(projIn, { zIndex: 0 }, "<0.5")
			.to(inCont, { stagger: 0.2, duration: 1, x: 0, ease: "power4.out" }, "<")
			.to(inCont, { stagger: 0.2, duration: 0.4, opacity: 1, ease: "none" }, "<0.2")
			.to(inImage, { duration: 1.5, ease: "power4.out", x: 0 }, "<")
			.to(inImage, { duration: 0.4, ease: "none", opacity: 1 }, "<");
	} else {
		tl.to(outCont, { stagger: 0.1, duration: 0.6, ease: "power2.in", x: "100%" })
			.to(outCont, { stagger: 0.1, duration: 0.2, ease: "none", opacity: 0 }, "<")
			.to(outImage, { x: "80%", duration: 0.6, ease: "power2.in" }, "<0.2")
			.to(outImage, { opacity: 0, duration: 0.2, ease: "none" }, "<0.3")
			.to(projOut, { zIndex: -1000 }, 0)
			.to(projIn, { zIndex: 0 }, "<0.5")
			.to(inCont, { stagger: 0.2, duration: 1, x: 0, ease: "power4.out" }, "<")
			.to(inCont, { stagger: 0.2, duration: 0.4, opacity: 1, ease: "none" }, "<0.2")
			.to(inImage, { duration: 1.5, ease: "power4.out", x: 0 }, "<")
			.to(inImage, { duration: 0.4, ease: "none", opacity: 1 }, "<");
	}
};

export default nextProjectInOutAnimation;
